<span
    id="magic-container"
    [class.full-width]="fullWidth"
    [class.disabled]="disabled"
    [style.fontSize]="fontSize"
    [attr.av-data]="avData"
    [attr.aria-disabled]="disabled">
    <div
        class="magic-button"
        role="button"
        [attr.tabindex]="disabled ? -1 : 0"
        (click)="handleClick($event)">
        <img *ngIf="showIcon" src="assets/img/navbar/generative_sparkles.svg" />
        <div class="label">{{ title }}</div>
    </div>
</span>
